interface FooterProps {
  scrollToSection: (id: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              WAVE RIDER
            </h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              波を感じ、潮風と過ごす、サステナブルな空間。<br />
              湘南の海を愛するすべての人へ。
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">クイックリンク</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('concept')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  コンセプト
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  メニュー
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('owner')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  オーナーストーリー
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('news')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  ニュース
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('access')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  アクセス
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">お問い合わせ</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span className="text-sm">神奈川県茅ヶ崎市中海岸X丁目</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <span className="text-sm">0467-XX-XXXX</span>
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span className="text-sm">11:00 - 18:00</span>
              </li>
              <li className="flex items-center">
                <i className="ri-calendar-close-line mr-2"></i>
                <span className="text-sm">定休日: 火曜日</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; 2024 SEASIDE CAFE WAVE RIDER. All rights reserved.
          </p>
          <a
            href="https://crescent.design"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by CresentDesign
          </a>
        </div>
      </div>
    </footer>
  );
}